import React, { PureComponent } from 'react';
import cn from 'classnames';

const ListItem = props => {
  const { children, className } = props;
  return <li className={cn(className, 'List__item')}>{children}</li>;
};

export default ListItem;
